<template>
    <b-modal id="client_rereferral" ref="client_rereferral" @hidden="resetForm"
             modal-class="modal-right modal-dialog-scrollable">
        <template v-slot:modal-title>
            Re-referral of<br>
            <div class="text-primary"> {{ client.data.attributes.name }}</div>
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Referral Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Referral Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.ref_date"
                            @input="'ref_date' in errors ? delete errors.ref_date : ''"
                            :input-props="{ class:'form-control' + ('ref_date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'ref_date' in errors"
                                                 v-text="'ref_date' in errors ? errors.ref_date[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Facility" class="has-float-label">
                        <template v-slot:label>
                            <span>Facility <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateFacility" v-model="selected.facility" :options="facilities"
                                  :border-danger="'facility_id' in errors"/>

                        <b-form-invalid-feedback :state="!'facility_id' in errors"
                                                 v-text="'facility_id' in errors ? errors.facility_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Comment" class="has-float-label">
                        <template v-slot:label>
                            <span>Comment <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea v-model="form.comment" rows="6"
                                         :class="{'border-danger': 'comment' in errors}"
                                         @input="'comment' in errors ? delete errors.comment : ''"
                                         placeholder="Comment"/>

                        <b-form-invalid-feedback :state="!('comment' in errors)"
                                                 v-text="'comment' in errors ? errors.comment[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row class="mb-4">
                <b-colxx md="12">
                    <vue-dropzone ref="fileDropZone" id="dropzone"
                                  @vdropzone-error="attachmentError"
                                  :destroy-dropzone="false" :options="dropzoneOptions"/>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('client_rereferral')" v-text="'Cancel'"/>

            <state-button variant="primary" :click="submitClientReferral">Submit</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";
import {mapGetters} from "vuex";
import VueDropzone from 'vue2-dropzone';
import moment from "moment";

export default {
    name: "ClientRereferralModal",

    components: {
        StateButton,
        VueDropzone,
    },

    props: ['client'],

    data() {
        return {
            datepicker: {
                ref_date: null,
            },
            selected: {
                facility: [],
            },
            dropzoneOptions: {
                url: 'url',
                thumbnailHeight: 160,
                acceptedFiles: '.jpg,.jpeg,.png,.pdf',
                maxFilesize: 10,
                previewTemplate: this.dropzoneTemplate(),
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.accessToken
                },
                dictDefaultMessage: 'Drop or Click here to upload REFERRAL LETTER.<br>Max file size 10MB.<br>Accepted file types: JPG, JPEG, PNG, PDF.',
                autoProcessQueue: false
            },
        }
    },

    computed: {
        ...mapGetters({
            form: 'getClientReferralForm',
            facilities: 'getSelectFacilities',
            errors: 'getReferralErrors',
        }),
    },

    watch: {
        'datepicker.ref_date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.ref_date = null;
            this.form.ref_date = moment(date).format('YYYY-MM-DD');
        },
    },


    methods: {
        attachmentError(file, message, xhr) {
            this.$refs.fileDropZone.removeFile(file);
            this.$notify('error filled', 'Error!', file.name + " could not be added!", {
                duration: 6000,
                permanent: false
            });
        },

        dropzoneTemplate() {
            return `<div class="dz-preview dz-file-preview mb-3">
                  <div class="d-flex flex-row "> <div class="p-0 w-30 position-relative">
                      <div class="dz-error-mark"><span><i></i>  </span></div>
                      <div class="dz-success-mark"><span><i></i></span></div>
                      <div class="preview-container">
                        <img data-dz-thumbnail class="img-thumbnail border-0" />
                        <i class="simple-icon-doc preview-icon"></i>
                      </div>
                  </div>
                  <div class="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                    <div> <span data-dz-name /> </div>
                    <div class="text-primary text-extra-small" data-dz-size /> </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                  </div>
                  <a href="#" class="remove" data-dz-remove> <i class="glyph-icon simple-icon-trash"></i> </a>
                </div>`
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        updateFacility(field) {
            if (field) {
                this.form.facility_id = field.facility_id;
            } else {
                this.form.facility_id = '';
            }
            'facility_id' in this.errors ? delete this.errors.facility_id : '';
        },

        submitClientReferral() {
            let payload = {
                client_id: this.client.client_id,
                form: {
                    ...this.form,
                },
            };
            return new Promise((success, fail) => {
                this.$store.dispatch('submitClientReferral', payload)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Client successfully re-referred!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('client_rereferral');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        uploadFiles(client) {
            let url = '/api/hms/clients/' + client.client_id + '/attachments';

            this.$refs.fileDropZone.setOption('url', url);

            this.$refs.fileDropZone.processQueue(client);
        },

        resetForm() {
            this.$store.commit('setClientReferralForm');

            this.selected = {
                facility: [],
            };

            this.$emit('closed');
        },
    },
}
</script>

<style scoped>

</style>
